import { render, staticRenderFns } from "./ShowValue.vue?vue&type=template&id=39c22432"
import script from "./ShowValue.vue?vue&type=script&lang=js"
export * from "./ShowValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports